
export interface IVisitConsentTreatmentRequest {
    isCPRAllowed: boolean;
}

export class VisitConsentTreatmentRequest implements IVisitConsentTreatmentRequest {
    isCPRAllowed: boolean;

    constructor(params: IVisitConsentTreatmentRequest) {
        this.isCPRAllowed = _.defaultTo(params.isCPRAllowed, false);
    }
}
